// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aaea5d07","581":"7a0cde15"}[chunkId] + ".chunk.js";
};